import { Tree, TreeList, TreeNode } from 'ra-tree-ui-materialui'
import React from 'react'
import { TextField } from 'react-admin'
import CategoryListActions from './CategoryListActions'
import { CategoryNodeActions } from './CategoryNodeActions'

const canDrag = () => false

export const CategoryList = ({ accessible, permissions, ...props }) => {
  return (
    <Tree
      {...props}
      actions={<CategoryListActions permissions={permissions} />}
      exporter={false}
      parentSource="parentId"
    >
      <TreeList>
        <TreeNode actions={<CategoryNodeActions permissions={permissions} />} canDrag={canDrag}>
          <TextField source="name" />
        </TreeNode>
      </TreeList>
    </Tree>
  )
}

export default CategoryList
